module.exports = __webpack_public_path__ + "static/media/officerup-new.5fb8d4c8.png";